import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core";
import React from "react";

interface IBB8SummaryBlockProps extends WithStyles {
  id?: string;
  title?: string;
  details?: string;
  type?: "action" | "icon" | "default";
}

const customerDetailsBlockStyles = createStyles((theme: Theme) => ({
  block: {
    display: "grid",
    minHeight: "0"
  },
  paragraph: {
    fontSize: "22px",
    margin: "4px 0",
    maxHeight: "100%",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
}));

const BB8SummaryBlock: React.SFC<IBB8SummaryBlockProps> = ({
  id,
  children,
  title,
  details,
  type = "default",
  classes
}) => {
  return (
    <div
      id={id}
      className={classes.block}
      style={{
        alignItems: "center",
        gridArea: type,
        gridTemplateColumns: type === "default" ? "100%" : "90px 45px",
        gridTemplateRows: type === "default" ? "14px 30px" : "auto",
        margin: type === "default" ? "12px 0" : "0"
      }}
    >
      {children ? (
        children
      ) : (
        <>
          <small>{title}</small>
          <p className={classes.paragraph} title={details}>
            {details}
          </p>
        </>
      )}
    </div>
  );
};

export default withStyles(customerDetailsBlockStyles)(BB8SummaryBlock);
